// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import categoryReducer from '../Redux/CategorySlice';
import productReducer from '../Redux/ProductSlice';
import cartReducer from '../Redux/CartSlice';
import userReducer from '../Redux/UserSlice';
import LPSlice from './LastProductSlice';

export const store = configureStore({
  reducer: {
    categories : categoryReducer,
    products : productReducer,
    carts:cartReducer,
    user:userReducer,
    LP: LPSlice,
  },
});
export default store;